var _g, _g2, _g3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountingIntegrationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 49,
    viewBox: "0 0 43 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2327_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3434 0C13.5985 0 9.73828 3.93174 9.73828 8.76446C9.73828 13.5972 13.5985 17.5289 18.3434 17.5289C23.0882 17.5289 26.9485 13.5972 26.9485 8.76446C26.9485 3.93174 23.0882 0 18.3434 0Z",
    fill: "url(#paint0_linear_2327_5275)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2327_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0482 23.2552C26.6924 20.8188 23.5692 19.4771 20.2541 19.4771H16.4296C13.1145 19.4771 9.99132 20.8188 7.63543 23.2552C5.29108 25.6796 4 28.8799 4 32.2667C4 32.8045 4.42809 33.2405 4.95612 33.2405H31.7276C32.2556 33.2405 32.6837 32.8045 32.6837 32.2667C32.6837 28.8799 31.3926 25.6796 29.0482 23.2552Z",
    fill: "url(#paint1_linear_2327_5275)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2327_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.962 24.3207L30.4105 20.2253C30.1504 20.0806 29.8352 20.0841 29.5782 20.234L22.2368 24.3298C21.9558 24.4873 21.7813 24.7881 21.7813 25.1147V30.4684C21.7755 32.9351 22.5495 35.3376 23.9889 37.3212C25.1767 38.9653 26.769 40.2612 28.6056 41.0778L29.622 41.5327C29.7322 41.5829 29.852 41.6073 29.9724 41.6042C30.0925 41.6021 30.2113 41.578 30.3229 41.5327L31.4703 41.0332C33.5321 40.1476 35.2931 38.6645 36.534 36.7681C37.7772 34.8716 38.4387 32.6416 38.435 30.3614V25.1147C38.4281 24.7829 38.2478 24.4803 37.962 24.3207Z",
    fill: "url(#paint2_linear_2327_5275)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9268 33.7247C28.6712 33.724 28.4283 33.61 28.2613 33.4124L26.2728 31.0393C25.9584 30.6646 26.0015 30.1014 26.369 29.7811C26.7368 29.4608 27.2898 29.5048 27.6043 29.8794L29.0322 31.5833L32.9916 28.3003C33.3667 27.9873 33.9196 28.0431 34.2266 28.425C34.5339 28.807 34.4791 29.3702 34.1041 29.6832L29.4788 33.5197C29.3251 33.6532 29.129 33.7261 28.9268 33.7247Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2327_5275",
    x: 6.08761,
    y: 0,
    width: 24.5123,
    height: 24.8302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2327_5275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2327_5275",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2327_5275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2327_5275",
    x: 0.349325,
    y: 19.4771,
    width: 35.9849,
    height: 21.065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2327_5275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2327_5275",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2327_5275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2327_5275",
    x: 18.1306,
    y: 20.1191,
    width: 23.9537,
    height: 28.7867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2327_5275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2327_5275",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2327_5275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2327_5275",
    x1: 23.2719,
    y1: 0.4604,
    x2: 5.01087,
    y2: 8.76107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2327_5275",
    x1: 26.5561,
    y1: 19.8385,
    x2: 7.53769,
    y2: 38.1886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2327_5275",
    x1: 34.8773,
    y1: 20.6835,
    x2: 15.9882,
    y2: 27.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingIntegrationsIcon);
export default __webpack_public_path__ + "static/media/accountingIntegrationsIcon.d6d76c0118de546ccf59e7c0a1acb01b.svg";
export { ForwardRef as ReactComponent };